import request from '../services/request';
import { PATH } from './path';
// 任务列表
export const requestTaskList = async params => {
  return request({
    url: PATH.queryHistory.getTaskList,
    params
  });
};
// 下载结果
export const requestDownloadResult = async params => {
  return request({
    url: PATH.queryHistory.downloadResult,
    method: 'get',
    params
  });
};
// 终止任务
export const requestCancelTask = async data => {
  return request({
    url: PATH.queryHistory.cancelTask,
    method: 'post',
    data
  });
};
// 分页查看结果
export const requestTempResult = async params => {
  return request({
    url: PATH.queryHistory.tempResult,
    params
  });
};
